import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ParticipantformService {
  currentEvent: number;
  //selectedValue: string;
  //event_json: string;

  change_event_fields(selectedValue) {
    //alert('Event changed ' + selectedValue);

    this.currentEvent=selectedValue;

    //this.event_json = JSON.parse(localStorage.getItem('currentUser'));

  }

  constructor() {}
}
